<template>
  <div>
    <!--支付二次确认弹框-->
    <ConfirmDialog
      :dialogVisible="payDialogVisible"
      @dialogCancel="payDialogCancel"
      @dialogConfirm="payDialogConfirm"
    >
      <div class="dialog-content">
        <div class="order-kouchu-wrap">
          <p class="dialog-title">{{ $t('app.tip') }}</p>
          <p class="kouchu-tips">{{ $t('app.auto_11_3c1407e3') }}</p>
          <ul class="kouchu-money-ul">
            <li>
              裂变奖金账户：{{ this.formLabelAlign.voucherAccountPayMoney }}元
            </li>
            <li>现金账户：{{ this.formLabelAlign.accountPayMoney }}元</li>
            <li>金账户：{{ this.formLabelAlign.totalGoldPayMoney }}元</li>
            <li>提货券帐户：{{ this.formLabelAlign.deliveryMoney }}元</li>
          </ul>
        </div>
      </div>
    </ConfirmDialog>

    <!-- 付款 -->
    <FreightProcure2Pay
      v-if="dialogVisiblePay"
      :dialogVisiblePay="dialogVisiblePay"
      :orderId="payData.orderId"
      :campusId="payData.campusId"
      :orderNo="payData.orderNo"
      :orderType="'callCenter'"
      @submitPay="submitPay"
      @cancelSubitPay="cancelSubitPay"
      @closeProcure2Pay="closeProcure2Pay"
      @bankRransferPay="bankRransferPay"
    />
    <!--微信、支付宝支付-->
    <Procure3Pay
      v-if="procure3PayDialog"
      :procure3PayDialog="procure3PayDialog"
      :elsePayMoney="formLabelAlign.elsePayMoney"
      :Choice="payType"
      :orderNo="payData.orderNo"
      :orderType="'callCenter'"
      @agentPaySuccess="agentPaySuccess"
      @paySuccess="paySuccess"
      @closeProcure3PayDialog="closeProcure3PayDialog"
    >
    </Procure3Pay>
    <ConfirmDialog
      :dialogVisible="dialogCancel"
      @dialogCancel="dialogCancel = false"
      @dialogConfirm="canelConfirm"
      width="500px"
    >
      <div
        :style="{
          padding: '10px',
          textAlign: 'center',
          fontSize: '16px',
          marginTop: '40px',
        }"
      >{{ $t('app.auto_12_21efd9b0') }}<br />{{ $t('app.auto_13_c84c9c0a') }}</div>
    </ConfirmDialog>
    <!--付款-对公转账-->
    <BankRransferModal
      v-if="bankRransferDialogVisible"
      :bankRransferDialogVisible="bankRransferDialogVisible"
      :payData="payData"
      :companyInfo="companyInfo"
      :formLabelAlign="formLabelAlign"
      :orderType="'callCenter'"
      @closeBankRransfer="closeBankRransfer"
      @bankRransferSuccess="bankRransferSuccess"
    />
    <!--付款成功或者失败-->
    <el-dialog
      center=""
      :title="payResultTitle"
      custom-class="MyDialog pay-result-dialog"
      :visible.sync="showPayResultDialog"
      :show-close="false"
      width="500px"
    >
      <div class="pay-result">
        <template v-if="isSuccess">
          <img src="@/assets/images/agent/pay_success.png" />
          <p class="result-tips">成功支付￥{{ money }}元</p>
        </template>
        <template v-else>
          <img src="@/assets/images/agent/pay_fail.png" />
          <p class="result-tips">未能成功支付￥{{ money }}元</p>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="hidePayResultDialog"
          >{{ $t('app.gotIt') }}</el-button
        >
      </span>
    </el-dialog>

    <!-- 充值话费弹框UI及交互 -->
    <el-dialog
      title="充值话费"
      v-if="payType === 'recharge'"
      custom-class="MyDialog recharge-dialog"
      :visible.sync="rechargeDialogVisible"
      :close-on-click-modal="false"
      width="580px">
      <el-form label-position="left">
        <el-form-item label-width="84px" style="margin-bottom:0px;" :label="$t('app.label')">
          <span>{{ phoneBillData.phoneBill }}</span>
        </el-form-item>
        <el-form-item label-width="84px" style="margin-bottom:0px;" :label="$t('app.label')">
          <el-input
            v-model.number="billAmount"
            style="width:120px;margin-right:4px;"
            :placeholder="$t('app.pleaseEnter')"
          >
          </el-input>
          <span>{{ $t('app.yuan') }}</span><span>{{ $t('app.auto_14_7788d61a') }}</span>
        </el-form-item>
        <el-form-item label-width="84px" style="margin-bottom:0px;" :label="$t('app.label')">
          <div>
            <span style="font-size:20px;color:#1890FF;font-weight:bold;">{{ billAmount ? billAmount : 0 }}元</span>
            <span>(可通话{{ calculateMinutes }}分钟)</span>
          </div>
          <div class="agreement-wrap" @click="switchProtocol">
            <input type="checkbox" class="checkbox" v-model="isSelectProtocol">
            <span class="pay-tips">{{ $t('app.auto_36_2c8b792e') }}</span>
            <a class="agreement-link" target="_blank" href="https://sqaipm.yuque.com/ggrkbp/gcm3rp/ws7h6g6vxqxudcta">{{ $t('app.auto_37_e5314cea') }}</a>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button plain @click="closePaymentDialog">{{ $t('app.cancel') }}</el-button>
        <el-button type="primary" @click="billPayment">{{ $t('app.auto_38_657cc6d0') }}</el-button>
      </span>
    </el-dialog>

    <!-- 开通外呼服务 -->
    <el-dialog
      title="开通外呼服务"
      custom-class="MyDialog"
      v-if="payType === 'open'"
      :visible.sync="openCalloutDialogVisible"
      :close-on-click-modal="false"
      width="580px">
      <el-form label-position="left" class="pay-wrap">
        <el-form-item class="pay-item" label-width="90px" :label="$t('app.label')">
          <div>
            <span class="strong-text">28.8元</span>
            <span>{{ $t('app.auto_18_68eb91fb') }}</span>
          </div>
        </el-form-item>
        <el-form-item class="pay-item" label-width="90px" :label="$t('app.label')">
          <div>
            <span class="strong-text">170.00元/月</span>
            <div class="pay-tip">{{ $t('app.auto_31_5b3591c1') }}</div>
          </div>
        </el-form-item>
        <el-form-item class="pay-item" label-width="90px" :label="$t('app.label')">
          <el-input-number size="small" v-model.number="monthNum"
              @input="limitNumber" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item class="pay-item" label-width="90px" :label="$t('app.label')">
          <div>
            <span class="strong-text">{{ totalPrice }}元</span>
            <span>(有效期{{ selectedMonth }}个月)</span>
            <div class="pay-tip">
              <el-checkbox v-model="renewChecked">{{ $t('app.auto_32_34c314f2') }}</el-checkbox>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="pay-item">
          <p class="intro-text">{{ $t('app.auto_21_febbef1e') }}<span style="color:#EE4B4E;">{{ $t('app.auto_22_19c4a75b') }}</span>{{ $t('app.auto_23_c7c89db7') }}</p>
          <p class="intro-text">{{ $t('app.auto_1724_16ad7868') }}<span style="color:#EE4B4E;">{{ $t('app.auto_34_2e929559') }}</span>
          </p>
          <p class="intro-text">{{ $t('app.auto_26_f93ba179') }}<span style="color:#EE4B4E;">{{ $t('app.auto_27_d1819be1') }}</span>
          </p>
          <div class="agreement-wrap" @click="switchProtocol">
            <input type="checkbox" class="checkbox" v-model="isSelectProtocol">
            <span class="pay-tips">{{ $t('app.auto_28_1d2a816b') }}</span>
            <a class="agreement-link" target="_blank" href="https://sqaipm.yuque.com/ggrkbp/gcm3rp/ws7h6g6vxqxudcta">{{ $t('app.auto_29_1b861332') }}</a>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button plain @click="closePaymentDialog">{{ $t('app.cancel') }}</el-button>
        <el-button type="primary" @click="immediatePayment">{{ $t('app.auto_30_fc80b0ff') }}</el-button>
      </span>
    </el-dialog>

    <!-- 续费外呼服务 -->
    <el-dialog
      title="开通外呼服务"
      custom-class="MyDialog"
      v-if="payType === 'renew'"
      :visible.sync="renewCalloutDialogVisible"
      :close-on-click-modal="false"
      width="580px">
      <el-form label-position="left" class="pay-wrap">
        <el-form-item class="pay-item" label-width="90px" :label="$t('app.label')">
          <div>
            <span class="strong-text">170.00元/月</span>
            <div class="pay-tip">{{ $t('app.auto_19_6aed0f56') }}</div>
          </div>
        </el-form-item>
        <el-form-item class="pay-item" label-width="90px" :label="$t('app.label')">
          <el-input-number size="small" v-model.number="monthNum"
              @input="limitNumber" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item class="pay-item" label-width="90px" :label="$t('app.label')">
          <div>
            <span class="strong-text">{{ totalPrice }}元</span>
            <span>(有效期{{ monthNum }}个月)</span>
            <div class="pay-tip">
              <el-checkbox v-model="renewChecked">{{ $t('app.auto_20_a2a536d4') }}</el-checkbox>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="pay-item">
          <p class="intro-text">{{ $t('app.auto_1733_2683badf') }}<span style="color:#EE4B4E;">{{ $t('app.auto_25_3e832b4e') }}</span>
          </p>
          <p class="intro-text">{{ $t('app.auto_35_056836b2') }}</p>
          <div class="agreement-wrap" @click="switchProtocol">
            <input type="checkbox" class="checkbox" v-model="isSelectProtocol">
            <span class="pay-tips">{{ $t('app.auto_15_6c5f790c') }}</span>
            <a class="agreement-link" target="_blank" href="https://sqaipm.yuque.com/ggrkbp/gcm3rp/ws7h6g6vxqxudcta">{{ $t('app.auto_16_649497cd') }}</a>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button plain @click="closePaymentDialog">{{ $t('app.cancel') }}</el-button>
        <el-button type="primary" @click="immediatePayment">{{ $t('app.auto_17_8032e637') }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import FreightProcure2Pay from "@/components/FreightProcure2Pay";
import { queryCompanyInfo } from "@/api/AgentAccount";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { purchaseOrderPay } from "@/api/AccountInterface";
import BankRransferModal from "@/components/BankRransferModal";
import { payCallCenter, renewal, recharge } from '@/api/SaleCenter';
import { debounce} from "@/util/util";
import pubsub from "pubsub-js";
export default {
  props: {
    payType: {
      type: String,
      default: '', // open: 开通外呼服务  renew: 续费外呼服务  recharge: 充值话费
    },
    showPaymentDialog: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      monthNum: 1,
      isSelectProtocol: false, // 是否勾选协议
      renewChecked: true, // 是否到期自动续费
      billAmount: '', // 充值话费
      payDialogVisible: false, // 二次支付的弹框
      payResultTitle: "",
      procure3PayDialog: false,
      isSuccess: false,
      money: 0,
      agentAccountObj: {},
      bankRransferDialogVisible: false, // 是否显示对公转账
      formLabelAlign: {},
      dialogCancel: false,
      dialogVisiblePay: false, //付款弹框show与否
      showPayResultDialog: false, //支付结果弹框
      totalPrice: 0,
      selectedMonth: 0,
      payData: {},
      companyInfo: {},
      rechargeDialogVisible: false, // 充值话费弹框
      openCalloutDialogVisible: false, // 支付开通外呼服务
      renewCalloutDialogVisible: false, // 续费外呼服务
    };
  },
  components: {
    FreightProcure2Pay,
    ConfirmDialog,
    BankRransferModal
  },
  computed: {
    // 充值计算可通话分钟数
    calculateMinutes() {
      if (this.billAmount === '') return 0;
      const minutes = this.billAmount / 0.12;
      const roundedMinutes = Math.round(minutes);
      return roundedMinutes;
    },
  },
  mounted() {
    this.queryCompanyInfo();
  },
  watch: {
    showPaymentDialog: {
      handler(newVal, oldVal) {
        switch (this.payType) {
          case 'open':
            this.openCalloutDialogVisible = newVal;
            break;
          case 'renew':
            this.renewCalloutDialogVisible = newVal;
            break;
          case 'recharge':
            this.rechargeDialogVisible = newVal;
            break;
          default:
            this.openCalloutDialogVisible = newVal;
            break;
        }
      },
      immediate: true
    },
    monthNum: {
      handler(newVal, oldVal) {
        if (newVal) {
          // 只有预售和开通才有28.8的开通费
          const openPrice = this.openCalloutDialogVisible ? 28.8 : 0;
          this.selectedMonth = newVal;
          const totalPrice = (newVal * 170) + openPrice;
          this.totalPrice = totalPrice.toFixed(2).padEnd(4, '0');
        } else {
          this.selectedMonth = 0;
          this.totalPrice = 0;
        }
      },
      immediate: true
    }
  },
  methods: {
    // 关闭支付弹框
    closePaymentDialog() {
      switch (this.payType) {
        case 'open':
          this.openCalloutDialogVisible = false;
          break;
        case 'renew':
          this.renewCalloutDialogVisible = false;
          break;
        case 'recharge':
          this.rechargeDialogVisible = false;
          break;
        default:
          this.openCalloutDialogVisible = false;
          break;
      }
      this.$emit('close-payment-dialog');
    },
    async queryCompanyInfo(){
      try {
        let { data, code, message } = await queryCompanyInfo()
        if (code === 0) {
          this.companyInfo = data;
        } else {
          this.$message.error(this.$getCodeMessage(code, message))
        }
      } catch (error) {
        console.error(error);
        this.$message.error(this.$t('app.failed'));
      }
    },
    // 重置form表单数据，外呼服务
    resetPayForm() {
      this.monthNum = 0;
      this.isSelectProtocol = false;
      this.selectedMonth = 0;
      this.totalPrice = 0;
      this.renewChecked = true;
    },
    /**
    * 立即支付
    */
    immediatePayment: debounce(function(){
      if (this.monthNum == '') {
        this.$message.warning(this.$t('app.auto_52_cd58f41b'));
        return;
      }
      if (!this.isSelectProtocol) {
        this.$message.warning(this.$t('app.auto_53_9153b4fc'));
        return;
      }
      const agent_user_info = JSON.parse(localStorage.getItem('agent_user_info'));
      // 续费付款接口调用renewal接口，其他为payCallCenter接口
      const payFuncName = this.renewCalloutDialogVisible ? renewal : payCallCenter;
      payFuncName({
        activationMonths: this.monthNum,
        curUserId: agent_user_info.id,
        isAutoRenewal: this.renewChecked ? 1 : 2, // 是否自动续期 1：续期，2：不续期
      }).then(res => {
        if (res.code == 0) {
          this.payData = res.data;
          this.dialogVisiblePay = true;
        } else {
          this.$message.error(this.$getCodeMessage(res.code, res.message, res.messageArgs));
        }
      })
    }, 500, true),
    // 充值话费
    billPayment: debounce(function () {
      const billAmount = this.billAmount;
      if (billAmount == '') {
        this.$message.warning(this.$t('app.auto_54_21ddab8a'));
        return;
      }
      if (!this.isSelectProtocol) {
        this.$message.warning(this.$t('app.auto_55_4577be6a'));
        return;
      }
      const agent_user_info = JSON.parse(localStorage.getItem('agent_user_info'));
      recharge({
        amount: billAmount,
        curUserId: agent_user_info.id,
      }).then(res => {
        if (res.code == 0) {
          this.payData = res.data;
          this.dialogVisiblePay = true;
        } else {
          this.$message.error(this.$getCodeMessage(res.code, res.message, res.messageArgs));
        }
      })
    }, 500, true),
    limitNumber(e) {
      const value = parseInt(String(e).replace(/[^\d]+/g, ''), 10);
      //如果输入框数值大于360，取余计算
      if (value >= 1 && value <= 12) {
        this.monthNum = value;
      } else {
        this.monthNum = '';
      }
    },
    switchProtocol() {
      this.isSelectProtocol = !this.isSelectProtocol;
    },
    submitPay(fromPayData, payType, agentAccountObj, type) {
      this.dialogVisiblePay = false;
      this.formLabelAlign = fromPayData;
      this.payType = payType;
      if (type != "onlyAgentPay") {
        this.payDialogVisible = true;
      }
      this.payDialogVisible = true;
      if (type == "submitAndAgentPay") {
        this.dialogPayType = type;
      } else if (type == "paymentFN") {
        this.handleClick(this.rowData);
        this.dialogPayType = type;
      } else if (type == "onlyAgentPay") {
        // 只有现金支付
        this.agentPay();
      }
    },
    // 支付宝、微信
    agentPay() {
      this.payDialogVisible = false;
      this.procure3PayDialog = true;
    },
    cancelSubitPay() {
      this.dialogVisiblePay = false;
    },
    closeProcure2Pay() {
      this.dialogVisiblePay = false;
    },
    // 二次支付弹框取消
    payDialogCancel() {
      this.payDialogVisible = false;
    },
    // 二次弹框确认
    payDialogConfirm() {
      this.submit();
    },
    hidePayResultDialog() {
      this.showPayResultDialog = false;
      this.procure3PayDialog = false;
      this.openCalloutDialogVisible = false; // 开通
      this.renewCalloutDialogVisible = false; // 续费
      this.rechargeDialogVisible = false; // 充值
    },
    agentPaySuccess() {
      this.procure3PayDialog = false;
    },
    closeBankRransfer() {
      this.bankRransferDialogVisible = false;
    },
    bankRransferSuccess() {
      this.bankRransferDialogVisible = false;
      this.openCalloutDialogVisible = false; // 开通
      this.renewCalloutDialogVisible = false; // 续费
      this.rechargeDialogVisible = false; // 充值
    },
    // 对公转账
    bankRransferPay(formLabelAlign, payType, agentAccountObj) {
      this.dialogVisiblePay = false;
      this.bankRransferDialogVisible = true;
      this.formLabelAlign = formLabelAlign;
      this.payType = payType;
      this.agentAccountObj = agentAccountObj;
    },
    paySuccess(money, isSuccess) {
      this.payResultTitle = isSuccess ? this.$t('app.auto_56_cea773ed') : this.$t('app.auto_57_23073796');
      this.money = money;
      this.isSuccess = isSuccess;
      this.showPayResultDialog = true;
    },
    closeProcure3PayDialog() {
      this.procure3PayDialog = false;
    },
    submit() {
      const {
        accountPayMoney,
        deliveryMoney,
        voucherAccountPayMoney,
        totalGoldPayMoney,
      } = this.formLabelAlign;
      purchaseOrderPay({
        agentMoney: accountPayMoney,
        realTimeMoney: 0,
        bankInfo: {
          fileUrl: [],
          money: 0,
          paySysNo: "",
          payTime: "",
          remark: "",
        },
        orderNo: this.payData.orderNo, //-1
        voucherAccountMoney: voucherAccountPayMoney, // 2
        goldMoney: totalGoldPayMoney, //
        goldAccount: this.agentAccountObj.goldAccount, // 2
        halfGoldAccount: this.agentAccountObj.halfGoldAccount, // 2
        payMethod: this.payType,
        deliveryMoney: deliveryMoney,
      }).then((ret) => {
        if (ret.code == 0) {
          if (this.dialogPayType == "submitAndAgentPay") {
            this.agentPay();
          } else {
            this.payDialogVisible = false;
            this.openCalloutDialogVisible = false; // 开通
            this.renewCalloutDialogVisible = false; // 续费
            this.rechargeDialogVisible = false; // 充值
          }
        } else {
          this.$message.error(this.$getCodeMessage(ret.code, ret.message, ret.messageArgs) || this.$t('app.auto_59_a1e1594b'));
        }
      });
    },
    canelConfirm() {},
  },
};
</script>

<style lang="scss" scoped>
.pay-wrap {
  .pay-item {
    color: #666;
    font-size: 14px;
    margin-bottom: 5px;
    .agreement-wrap {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      -webkit-user-select: none;
      user-select: none;
      margin-top: 10px;
      .checkbox:checked {
        background: #4a83e8;
        border: 1px solid #4a83e8;
      }
      .checkbox {
        -webkit-appearance: none;
        -moz-appearance: none;
        outline: none;
        width: 18px;
        height: 18px;
        background-color:#ffffff;
        border-radius: 5px;
        margin-right: 8px;
        padding:0;
        position:relative;
        display:inline-block;
        /*文字对齐方式*/
        vertical-align:top;
        transition:background-color ease 0.1s;
        border: 1px solid #D9D9D9;
        &:hover {
          cursor:pointer;
        }
      }
      .checkbox:checked::after {
        content:'';
        top:3px;
        left:3px;
        position:absolute;
        border:#fff solid 2px;
        border-top:none;
        border-right:none;
        height:5px;
        width:8px;
        transform:rotate(-45deg);
      }
      .pay-tips {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        line-height: 20px;
        text-align: left;
        font-style: normal;
      }
      .agreement-link {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #1890FF;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        text-decoration-line: underline;
      }
      &:hover {
        cursor: pointer;
      }
    }
    .pay-tip {
      line-height: 20px;
    }
    .strong-text {
      font-size: 20px;
      color: #1890FF;
      font-weight: bold;
    }
    .intro-text {
      line-height: 20px;
      color: #999;
      font-size: 12px;
    }
  }
}
.recharge-dialog {
  .agreement-wrap {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    -webkit-user-select: none;
    user-select: none;
    margin-top: 45px;
    .checkbox:checked {
      background: #4a83e8;
      border: 1px solid #4a83e8;
    }
    .checkbox {
      -webkit-appearance: none;
      -moz-appearance: none;
      outline: none;
      width: 18px;
      height: 18px;
      background-color:#ffffff;
      border-radius: 5px;
      margin-right: 8px;
      padding:0;
      position:relative;
      display:inline-block;
      /*文字对齐方式*/
      vertical-align:top;
      transition:background-color ease 0.1s;
      border: 1px solid #D9D9D9;
      &:hover {
        cursor:pointer;
      }
    }
    .checkbox:checked::after {
      content:'';
      top:3px;
      left:3px;
      position:absolute;
      border:#fff solid 2px;
      border-top:none;
      border-right:none;
      height:5px;
      width:8px;
      transform:rotate(-45deg);
    }
    .pay-tips {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #333333;
      line-height: 20px;
      text-align: left;
      font-style: normal;
    }
    .agreement-link {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #1890FF;
      line-height: 20px;
      text-align: left;
      font-style: normal;
      text-decoration-line: underline;
    }
    &:hover {
      cursor: pointer;
    }
  }
}
::v-deep .el-table__header-wrapper .el-checkbox {
  visibility: hidden;
}

::v-deep .el-table .el-table__cell {
  text-align: center;
}

</style>
<style lang="scss">
.pay-result {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  .result-tips {
    font-size: 20px;
    font-weight: bolder;
  }
}
.kouchu-money-ul {
  padding-left: 20px;
}
.star_1 {
  position: absolute;
  width: 1366px;
  height: 768px;
  left: 50%;
  top: 50%;
  margin-left: -683px;
  margin-top: -384px;
  background: url('@/assets/images/costCenter/start_1.png') no-repeat center center;
  background-size: 100% 100%;
  z-index: 1;
}
</style>
